document.addEventListener('DOMContentLoaded', function () {
  const activeStoriesSections = document.querySelectorAll('.section_active-stories:not(.is-our-stories)');

  activeStoriesSections.forEach((section) => {
    const contentSwiperContainer = section.querySelector('.active-stories-content');
    const photosSwiperContainer = section.querySelector('.active-stories-photos');
    const prevButton = section.querySelector('.arrow.is-left');
    const nextButton = section.querySelector('.arrow.is-right');

    if (contentSwiperContainer && photosSwiperContainer && prevButton && nextButton) {

      // Photo swiper initialization (The main controller)
      const photoSwiper = new Swiper(photosSwiperContainer, {
        slidesPerView: "auto",
        loop: true,
        spaceBetween: 20,
        speed: 300,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        },
        allowTouchMove: true,
      });

      // Content swiper initialization (The follower)
      const contentSwiper = new Swiper(contentSwiperContainer, {
        slidesPerView: "auto",
        loop: true,
        speed: 300, 
        allowTouchMove: true,
      });

      // Manual Synchronization Logic
      const synchronizeSwipers = (sourceSwiper, targetSwiper) => {
        if (targetSwiper.realIndex !== sourceSwiper.realIndex) {
          targetSwiper.slideToLoop(sourceSwiper.realIndex, 300);
        }
      };

      // Listen for changes in both swipers and synchronize
      photoSwiper.on("slideChange", function () {
        synchronizeSwipers(photoSwiper, contentSwiper);
      });

      contentSwiper.on("slideChange", function () {
        synchronizeSwipers(contentSwiper, photoSwiper);
      });
    }
  });
});

 

